import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
// import { PurchaseNotifications } from './components/PurchaseNotifications'
// Mount <PurchaseNotifications /> again once data/recentPurchases.ts is fed by real orders.

export function App() {
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3mlj82snzz920">
      <MetaPixel data-id="element-1" data-mp="3rbr9en3irte8" />
      <main data-id="element-2" data-mp="3rdaqgfx028h2">
        <Hero data-id="element-3" data-mp="3rdkg22e4udm8" />
        <SocialProofBar data-id="element-4" data-mp="3rd1all5o5hp3" />
        <PainGrid data-id="element-5" data-mp="3relwkmdx3sbc" />
        <ProductReveal data-id="element-6" data-mp="6hqtghuuhen" />
        <Tomes data-id="element-7" data-mp="4wwnrzgd0hb" />
        <Bonuses data-id="element-8" data-mp="5ggje8nxyxz" />
        <ValueStack data-id="element-9" data-mp="82k72sfnuax" />
        <Urgency data-id="element-10" data-mp="2zl3cjn8vpa6d" />
        <Pricing data-id="element-11" data-mp="2zlld2w2kqak3" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-12" data-mp="2zm4xqkjlzd1t" />
        <Guarantee data-id="element-13" data-mp="33m5cy7ej7s9x" />
        <Faq data-id="element-14" data-mp="33nq5jrhad155" />
        <Testimonials testimonials={moreTestimonials} title="More coaches, more Sundays back" background="cream" data-id="element-15" data-mp="33n6yx6x35z6f" />
        <CostOfInaction data-id="element-16" data-mp="3dkl60fx4dbm2" />
        <Close data-id="element-17" data-mp="3dlw5w4ng1z7w" />
      </main>
      <Footer data-id="element-18" data-mp="3dm5y7yvyoigr" />
    </div>;
}